import styled from "styled-components";

export const BlogComponentStyles = styled.main`
  background: #f5f5f7;
  padding-bottom: 1px;

  .search-title {
    padding-top: 3.5rem;

    h2 {
      font-size: 2rem;
      font-weight: 300;
      text-align: center;
    }
  }

  .no-result {
    font-size: 1.5rem;
    font-weight: 600;
  }

  .posts {
    padding: 15px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  ${(props) => props.theme.media.md} {
    .posts {
      padding: 30px 0;
      margin-left: -15px;
      margin-right: -15px;
    }
  }

  ${(props) => props.theme.media.lg} {
    .posts {
      padding: 60px 0;
    }
  }
`;

export const BlogTileStyles = styled.article`
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin: 15px 0;
  max-width: 33.75rem;
  padding-bottom: 107px;
  position: relative;
  transition: all 0.25s;

  &:hover {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  }

  .post__thumbnail-wrap img {
    width: 100%;
    object-fit: cover;
    ${(props) => props.theme.media.sm} {
      max-height: 303px;
    }
  }

  .post__preview {
    padding: 20px;
    min-height: 205px;

    .post__title {
      font-size: 1.45rem;
      font-weight: 400;
      line-height: 1.2;
      margin-bottom: 1.3rem;
      text-align: left;

      a {
        color: #444;
        text-decoration: none;
      }
    }

    .post-category {
      color: #737373;
      display: none;
      font-size: 0.7rem;
      font-weight: 500;
      letter-spacing: 0.5px;
      margin-bottom: 1.3rem;

      a {
        text-decoration: none;
        text-transform: uppercase;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    p {
      font-size: 1.0625rem;
      font-weight: 300;
      line-height: 1.35;
      margin: 0;
    }
  }

  .post__footer {
    padding: 20px;
    justify-content: space-between;
    background: #f5f5f7;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;

    .post__info {
      color: #737373;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      text-align: center;
      margin-top: 1em;

      .post__date {
        align-items: center;
        display: flex;
        margin-left: auto;
        margin-right: auto;

        .post__date__icon {
          display: inline-block;
          height: 13px;
          width: 13px;
          background: url(/static/images/icons/calendar.svg) no-repeat center;
          background-size: 13px 13px;
          margin-right: 5px;
        }
      }
    }
  }

  ${(props) => props.theme.media.sm} {
    padding-bottom: 82px;

    .post__preview {
      .post__title {
        margin-bottom: 0.3rem;
      }

      .post-category {
        display: block;
      }
    }

    .post__footer {
      display: flex;
    }
  }

  ${(props) => props.theme.media.md} {
    margin: 15px;
    flex-basis: calc(50% - 30px);
  }

  ${(props) => props.theme.media.lg} {
    .post__preview .post__title {
      font-size: 1.625rem;
    }
  }
`;

export const BlogCategoryListStyles = styled.div`
  .categories {
    display: none;
    padding: 30px 0;

    .categories__list {
      list-style: none;
      margin: 0;
      padding: 0;
      text-align: center;

      li {
        display: inline-block;
        line-height: 1;
        margin: 10px 15px;

        a {
          color: #444;
          text-decoration: none;

          &.active {
            font-weight: 600;
          }

          &.active,
          &:hover {
            color: #89d3c6;
            text-decoration: underline;
          }
        }
      }
    }
  }

  ${(props) => props.theme.media.sm} {
    .categories {
      display: block;
    }
  }

  ${(props) => props.theme.media.md} {
    .categories {
      padding: 60px 0 0;
    }
  }

  ${(props) => props.theme.media.lg} {
    .categories {
      padding: 80px 0 0;
    }
  }
`;

export const BlogHeroStyles = styled.div`
  padding: 140px 0 90px;
  background: #f5f5f7;
  background-size: cover;

  .hero-title {
    text-align: center;
    color: #3F5261;
    font-weight: 500;
    margin: 0 0 1rem;
    font-size: 30px;

    ${props => props.theme.media.lg} {
      font-size: 3.5rem;
    }
  }

  .hero-subtitle {
    text-align: center;
    color: #3F5261;
    margin: 0 0 2em;

    ${props => props.theme.media.lg} {
      font-size: 20px;
    }
  }

  .search-wrap {
    border: 2px solid #dcdcdd;
    background: #fff;
    display: flex;
    width: 100%;
    padding: 5px;
    border-radius: 5px;
    max-width: 700px;
    margin: 0 auto;
  }

  .search-input {
    background: transparent;
    flex-grow: 1;
    border: none;
    padding-right: 15px;
    width: 1rem;

    &:focus {
      outline: none;
    }
  }

  .btn--primary-clear {
    background: none;
    border: 2px solid #fdac76;
    color: #f15f22;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    :hover {
      color: #f15f22;
      border-color: #f69d5c;
      filter: brightness(1.3);
    }
  }

  .btn {
    border-radius: 0.2em;
    display: inline-block;
    font-weight: 500;
    letter-spacing: 0.3px;
    line-height: 1.5;
    min-width: 2rem;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: all 0.15s ease-in-out;
    user-select: none;
    vertical-align: middle;
  }

  ${(props) => props.theme.media.sm} {
    .search-wrap {
      padding: 10px;

      .search-icon {
        width: 22px;
        background: url(/static/images/icons/search.svg) no-repeat center;
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }

  ${(props) => props.theme.media.md} {
    .hero-title {
      font-size: 2.5rem;
    }

    .search-input {
      font-size: 31px;
      font-weight: 300;
    }
  }

  ${(props) => props.theme.media.lg} {
    .hero-title {
      font-size: 3.5rem;
    }
  }
`;
